<template>
  <span
    ref="wrapper"
    :class="`${cssStyle} tw-flex tw-items-center tw-gap-[5px] tw-h-[20px] tw-cursor-pointer tw-rounded-[4px] tw-px-[5px] tw-py-[3px] tw-text-[#FE9A05] tw-text-[11px] tw-not-italic tw-font-medium tw-leading-[130%] wrapper`"
    :style="{
      minWidth: maxWidth + 'px',
    }"
    data-cy="suggestion-button"
    @click="emit('onClicked', value)"
  >
    <span class="content"
      >{{
        getComponentUiText("app-component-suggestion-button-title-suggested-1")
      }}{{ value ? ` - ${label ? label : value}%` : "" }}</span
    >
    <span class="apply">{{
      getComponentUiText("app-component-suggestion-button-title-apply-1")
    }}</span>
  </span>
</template>

<script lang="ts" setup>
import { getComponentUiText } from "@/utils/utilities";
import { onMounted, ref } from "vue";

const wrapper = ref();

defineProps({
  value: {
    type: String,
    default: null,
  },
  label: {
    type: String,
    default: null,
  },
  cssStyle: {
    type: String,
    default: "",
  },
});

const emit = defineEmits(["onClicked"]);

const maxWidth = ref(0);

onMounted(() => {
  setTimeout(() => {
    maxWidth.value = wrapper.value?.clientWidth;
  }, 10);
});
</script>
<style scoped>
.wrapper {
  border-radius: 4px;
  border: 1px solid rgba(254, 154, 5, 0.15);
  width: fit-content;
}

.wrapper .content {
  display: inline-block;
}

.wrapper:hover .content {
  display: none;
}

.wrapper .apply {
  display: none;
  width: 100%;
  text-align: center;
}

.wrapper:hover .apply {
  display: inline-block;
}
</style>
